export enum ESensorType {
    UNKNOWN = 'unknown',
    EXTERNAL_SENSOR = 'external_sensor',
    DEVICE = 'device',
    ALARMS = 'alarms',
    FILL_SENSOR_ONE = 'fill_sensor_one',
    LIGHT_SENSOR = 'light_sensor',
    VEHICLE = 'vehicle',
    MILLER_CAN = 'miller_can',
    WELDING_CAN_ONE = 'welding_can_one',
    INDOOR_BLUE_ANCHOR = 'indoor_blue_anchor',
    INDOOR_BLUE_TAG = 'indoor_blue_tag',
}

export function getSensorTypeFromString(value: string): ESensorType {
    switch (`${value}`.toLowerCase().trim()) {
        case 'device':
            return ESensorType.DEVICE;

        case 'light_sensor':
            return ESensorType.LIGHT_SENSOR;

        case 'alarms':
            return ESensorType.ALARMS;

        case 'welding_can_one':
            return ESensorType.WELDING_CAN_ONE;

        case 'miller_can':
            return ESensorType.MILLER_CAN;

        case 'indoor_blue_anchor':
            return ESensorType.INDOOR_BLUE_ANCHOR;

        case 'indoor_blue_tag':
            return ESensorType.INDOOR_BLUE_TAG;

        case 'external_sensor':
            return ESensorType.EXTERNAL_SENSOR;

        case 'fill_sensor':
        case 'fill_sensor_one':
            return ESensorType.FILL_SENSOR_ONE;

        case 'vehicle':
            return ESensorType.VEHICLE;
        default:
            return ESensorType.UNKNOWN;
    }
}
